module.exports = __webpack_public_path__ + "media/packs/images/flags/PE-91ea758b36bb4e7c06205b1ba8a5beab.png";